export default __webpack_public_path__ + "0c52c9a3713ffdaf7b9c55646fd1585c.png";